import { createIsomorphicFn } from "@tanstack/react-start";
import { localizeHref } from "~/lib/language-lens/locale-url";
import { createSocialHeadMeta } from "~/lib/social-head";
import type { SocialMetadata } from "~/lib/social-metadata";

// The server document owns its configured canonical. On SPA navigation the
// root request metadata is gone, so the active public route owns its head.
export const createPublicBrowseHead = createIsomorphicFn()
  .server(
    (
      _path: "/explore" | "/stocks" | "/currencies" | "/build",
      metadata: SocialMetadata,
    ) => ({
      meta: createSocialHeadMeta(metadata),
    }),
  )
  .client(
    (
      path: "/explore" | "/stocks" | "/currencies" | "/build",
      metadata: SocialMetadata,
    ) => {
      if (typeof window === "undefined")
        return { meta: createSocialHeadMeta(metadata) };
      const href = new URL(localizeHref(path), window.location.origin).href;
      return {
        links: [{ rel: "canonical", href }],
        meta: [
          ...createSocialHeadMeta(metadata),
          { property: "og:url", content: href },
        ],
      };
    },
  );
